<template>
<div>
<b-container fluid no-gutters>
  <b-row class="itemRow top">
    <b-col cols="9">
      <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Agenda Item" label-for="input_sm" label-class="sr-only">
        <b-form-input id="topicNew" style="Xwidth:30rem" v-model="editAgendaItem.topic" placeholder="Title for this agenda item" autofocus autocomplete="off" size="lg"></b-form-input>
      </b-form-group>
    </b-col>

    <b-col cols="3" style="display: flex;
    justify-content: flex-end;padding: 0">
      <span v-bind:class="'itemTime i' + itemNo">
        <font-awesome-icon :icon="['far', 'clock']" style="position:relative; left:3.1rem;top:.06rem;z-index:999"/>
          <b-form-input list="durations" size="lg" id="durationNew" v-model="editAgendaItem.duration" v-bind:class="' itemTime i' + itemNo" style="display:inline-block;width:5rem;padding-left:2rem; margin-right:0;position:relative;left:1.3rem;z-index:1"></b-form-input>
          <datalist id="durations">
          <option v-for="duration in itemDurations">{{ duration }}</option>
          </datalist>
          <span style="z-index:2;position:relative;left:0">m</span>
      </span>
    </b-col>
  </b-row>

  <b-row class="itemRow" style="height:2.2rem">
    <b-col cols="9">
      <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Objective" label-for="input_sm" label-class="sr-only">
        <b-form-input id="topicObjective" v-model="editAgendaItem.objective" placeholder="Objective for this item" size="sm" autocomplete="off"></b-form-input>
        </b-form-group>
    </b-col>
  </b-row>

  <b-row>
    <b-col cols="12">
      <b-button v-if="!showDescription && !editAgendaItem.description" variant="link" style="font-size: 0.75rem; color: #808080; margin: 0; padding: 0" @click="showDescription=true">+ Add Description</b-button>
      <b-form-textarea v-if="showDescription || editAgendaItem.description" placeholder="Add a description" v-model.trim="editAgendaItem.description" style="width:34rem" size="sm"></b-form-textarea>
    </b-col>
  </b-row>

  <b-row>
    <b-col cols="12">

      <div v-if="editAgendaItem.links && editAgendaItem.links.length > 0" style="display: flex; margin-top:1rem">
        <div v-for="(link) in editAgendaItem.links" v-bind:key="link.url" class="itemLink">
            <b-badge variant="light">
            <a target="_blank" :href="link.url" style="Xcolor:black">
              <font-awesome-icon :icon="['fas', 'link']" size="1x" style="color:#afadad;cursor:pointer" />
              {{link.title}}
            </a>
            <b-button variant="link" style="padding:0;line-height:1rem; vertical-align: inherit;color: black" @click="removeLink(link)">x</b-button>
          </b-badge>&nbsp;&nbsp;
        </div>
      </div>
      <b-button variant="link" style="font-size: 0.75rem; color: #808080; margin: 0; padding:0" @click="showLinkForm=true">+ Add a Link</b-button>

    </b-col>
  </b-row>

  <b-row class="itemRow">
    <b-col cols="8">
    <label for="ownernew">Owner:</label>&nbsp;
    <b-form-input id="ownernew" class="mt3" v-model="editAgendaItem.owner" size="sm"></b-form-input>
    </b-col>
    <b-col style="display:flex; align-items:flex-end; justify-content: flex-end">
      <span>
      <b-btn variant="secondary" @click="$emit('cancelEditAgendaItem')" size="sm">Cancel</b-btn>&nbsp;
      <b-btn variant="primary" @click="saveItem()" size="sm">{{mode == 'update' ? 'Save' : 'Create Item'}}</b-btn>
    </span>
    </b-col>
  </b-row>

</b-container>


  <!--  Add Link Modal -->
   <b-modal id="modalAddLink" ref="modal" title="Add Link" v-model="showLinkForm" style="z-index:99999" @keydown.native.enter="alert('enter')" tabindex="0">
   <b-input type="url" size="sm" sm="5" style="width:29.5rem" v-model="linkURL" placeholder="URL to link to"></b-input>
   <b-input size="sm" style="width:20rem; margin-top:0.5rem" v-model="linkText" placeholder=" Text to display"></b-input>
  <div slot="modal-footer" class="w-100">
    <span style="float:right">
      <b-button size="sm" variant="secondary" @click="showLinkForm=false">Cancel</b-button>&nbsp;
      <b-button size="sm"  variant="primary" @click="addLinkURL">Add</b-button>
    </span>
  </div>
  </b-modal>

</div>
</template>
<script>
export default {
  props: ['mode', 'agendaItem', 'nextItemNo'],
  data () {
    return {
      editAgendaItem: this.agendaItem,
      itemDurations: ['5','10','15','30','45','60'],
      showDescription: false,
      showLinkForm: false,
      linkURL: '',
      linkText: ''
    }
  },
  computed: {
    itemNo () {
      return this.mode == 'update' ? this.agendaItem.position : this.nextItemNo
      // return this.agendaItem.position > -1 ? this.agendaItem.position : this.nextItemNo
    }
  },
  methods: {
    move (direction) {
      alert('direction=' + direction)
      this.agendaItem.direction=direction
      this.$emit('moveItem',this.agendaItem)
    },
    saveItem () {
      this.$emit('saveAgendaItem', this.editAgendaItem)
    },
    cancelEditItem () {
      this.agendaItem.topic = ''
      this.agendaItem.objective = ''
      this.agendaItem.owner = this.user.displayName
      this.agendaItem.duration = '15'
      this.agendaItem.links = []
      this.editAgendaIndex = -1
    },
    addLinkURL () {
      // this.$emit('saveLink', this.linkURL, this.linkText,this.agendaItem.id)
      if(!this.agendaItem.links) {
        this.agendaItem.links = []
      }
      this.editAgendaItem.links.push({url: this.linkURL, title: this.linkText})
      this.showLinkForm = false
      this.linkText = ''
      this.linkURL = ''
    },
    removeLink (link) {
      var newArr = this.editAgendaItem.links.filter(x => x.url != link.url)
      this.$set(this.editAgendaItem,'links', newArr)
    }
  }
}
</script>
<style scoped>
  .card{width:90%;margin-bottom:15px}

  .itemTime {
  Xfloat: right;
  margin-right: 0.3rem;
  font-weight: 400;
  font-size: 1.2rem;
}
input::-webkit-calendar-picker-indicator {
  display: none;
}
</style>
